import API from '../../API/endpoints';

export const SET_RECENT_DEPLOYMENT_PACKAGES = 'SET_RECENT_DEPLOYMENT_PACKAGES'
export const SET_SCHEDULED_DEPLOYMENT_PACKAGES = 'SET_SCHEDULED_DEPLOYMENT_PACKAGES'
export const SET_SAVED_DEPLOYMENT_PACKAGES = 'SET_SAVED_DEPLOYMENT_PACKAGES'
export const SET_DEPLOYMENT_PACKAGES_DETAILS = 'SET_DEPLOYMENT_PACKAGES_DETAILS'
export const SET_SAVE_PACKAGE = 'SET_SAVE_PACKAGE'
export const SET_RESET_DEPLOYMENT_LIST = 'SET_RESET_DEPLOYMENT_LIST'
export const SET_RECENT_PACKAGES_LOADING = 'SET_RECENT_PACKAGES_LOADING'
export const SET_SCHEDULED_PACKAGES_LOADING = 'SET_SCHEDULED_PACKAGES_LOADING'
export const SET_SAVED_PACKAGES_LOADING = 'SET_SAVED_PACKAGES_LOADING'
export const SET_PACKAGE_DETAILS_LOADING = 'SET_PACKAGE_DETAILS_LOADING'
export const SET_RESET_SAVED_DEPLOYMENT_PACKAGES = 'SET_RESET_SAVED_DEPLOYMENT_PACKAGES';

let recentDeploymentPackages_length :number;
let scheduleDeploymentPackages_length: number

export const getRecentDeploymentPackages_length = () => recentDeploymentPackages_length;
export const setRecentDeploymentPackages_length = (length: number) => {
    recentDeploymentPackages_length = length;
};

export const getSchedulDeploymentPackages_length = () => scheduleDeploymentPackages_length;
export const setScheduleDeploymentPackages_length = (length: number) => {
    scheduleDeploymentPackages_length = length;
};


export const setRecentDeploymentPackages = (payload: object) => {
    return {
        type: SET_RECENT_DEPLOYMENT_PACKAGES,
        payload: payload,
    }
}

export const setScheduledDeploymentPackages = (payload: object) => {
    return {
        type: SET_SCHEDULED_DEPLOYMENT_PACKAGES,
        payload: payload,
    }
}

export const setSavedDeploymentPackages = (payload: object) => {
    return {
        type: SET_SAVED_DEPLOYMENT_PACKAGES,
        payload: payload,
    }
}

export const setDeploymentPackageDetails = (payload: object) => {
    return {
        type: SET_DEPLOYMENT_PACKAGES_DETAILS,
        payload: payload,
    }
}

export const setSavedPackage = (payload: any) => {
    return {
        type: SET_SAVE_PACKAGE,
        payload: payload,
    }
}

export const resetDeploymentLst = () => {
    return {
        type: SET_RESET_DEPLOYMENT_LIST,
    }
}

export const resetSaveDeploymentPackages = () => {
    return {
        type: SET_RESET_SAVED_DEPLOYMENT_PACKAGES
    };
};

export const setRecentPackageApiLoading = (payload: any) => {
    return {
        type: SET_RECENT_PACKAGES_LOADING,
        payload: payload,
    }
}

export const setScheduledPackageApiLoading = (payload: any) => {
    return {
        type: SET_SCHEDULED_PACKAGES_LOADING,
        payload: payload,
    }
}


export const setSavedPackageApiLoading = (payload: any) => {
    return {
        type: SET_SAVED_PACKAGES_LOADING,
        payload: payload,
    }
}

export const setPackageDetailsApiLoading = (payload: any) => {
    return {
        type: SET_PACKAGE_DETAILS_LOADING,
        payload: payload,
    }
}

export const getRecentDeploymentPackeges = ({ orgId, history, token }: any) => (
    dispatch: any
) => {
    orgId = orgId ? orgId : localStorage.getItem('orgId')
    const reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`,
        },
    }
    const queryString = token
        ? `&type=immediate&limit=100&nextToken=${token ? token : ''}`
        : '&type=immediate&limit=100'

    dispatch(setRecentPackageApiLoading(true))
    fetch(`${API.deployments(orgId)}${queryString}`, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: '/',
                })
            } else {
                return result.json()
            }
        })
        .then((result) => {
            if (result) {
                setRecentDeploymentPackages_length(result.result.length);
                dispatch(setRecentDeploymentPackages(result))
                dispatch(setRecentPackageApiLoading(false))
            }
        })
        .catch((error) => {
            dispatch(setRecentPackageApiLoading(false))
        })
}


export const getScheduledDeploymentPackeges = ({ orgId, history, token }: any) => (
    dispatch: any
) => {
    orgId = orgId ? orgId : localStorage.getItem('orgId')
    const reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`,
        },
    }
    const queryString = token
        ? `&type=scheduled&limit=100&nextToken=${token ? token : ''}`
        : '&type=scheduled&limit=100'
    
    dispatch(setScheduledPackageApiLoading(true))
    fetch(`${API.deployments(orgId)}${queryString}`, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: '/',
                })
            } else {
                return result.json()
            }
        })
        .then((result) => {
            if (result) {
                setScheduleDeploymentPackages_length(result.result.length);
                dispatch(setScheduledDeploymentPackages(result))
                dispatch(setScheduledPackageApiLoading(false))
            }
        })
        .catch((error) => {
            dispatch(setScheduledPackageApiLoading(false))
        })
}

export const getSavedDeploymentPackeges = ({ orgId, history, token }: any) => (
    dispatch: any
) => {
    orgId = orgId ? orgId : localStorage.getItem('orgId')
    const reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`,
        },
    }
    const queryString = token
        ? `&limit=10&nextToken=${token ? token : ''}`
        : '&limit=10'

    dispatch(setSavedPackageApiLoading(true))
    fetch(`${API.saveDeployments(orgId)}${queryString}`, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: '/',
                })
            } else {
                return result.json()
            }
        })
        .then((result) => {
            if (result.result) {
                dispatch(setSavedDeploymentPackages(result))
                dispatch(setSavedPackageApiLoading(false))
            }
        })
        .catch((error) => {
            dispatch(setSavedPackageApiLoading(false))
        })
}

export const getDeploymentPackageDetails = ({ orgId, packageId, history }: any) => (
    dispatch: any
) => {
    const reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`,
        },
    }
    dispatch(setPackageDetailsApiLoading(true))

    fetch(API.singleDeployments(orgId, packageId), reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: '/',
                })
            } else {
                return result.json()
            }
        })
        .then((result) => {
            if (result.result) {
                dispatch(setDeploymentPackageDetails(result.result))
            }
            else {
                dispatch(setDeploymentPackageDetails({}))
            }
            dispatch(setPackageDetailsApiLoading(false))
        })
        .catch((error) => {
            dispatch(setPackageDetailsApiLoading(false))
        })
}

export const setSavePackage = ({ packageId, payload, history }: any) => async (
    dispatch: any
) => {
    try {
        const reqValues = {
            method: 'PATCH',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${localStorage.getItem('id_token')}`,
            },
        }
        const response = await fetch(API.package(packageId), reqValues);
        const result = await response.text();
        if (response.status === 200) {
            return { result: JSON.parse(result), isSuccess: true }
        } else {
            return { error: "Something went wrong", isSuccess: false }
        }
    } catch (error) {
    }
}

export const deleteSavedPackage = ({ orgId, packageId }: any) => async (
    dispatch: any
) => {
    try {
        const reqValues = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${localStorage.getItem('id_token')}`,
            },
        }
        const response = await fetch(API.singleDeployments(orgId, packageId), reqValues);
        const result = await response.text();
        if (response.status === 200) {
            return { result: JSON.parse(result), isSuccess: true }
        } else {
            return { error: "Something went wrong", isSuccess: false }
        }
    } catch (error) {
    }
}

